import { IdentityVerifyStatusModel } from "../model/profileBoostModel";
import { ProfileBoostAction } from "./profileBoost.action";

export interface ProfileBoostState {
  isBoosted: boolean;
  identityVerifyStatusModel: IdentityVerifyStatusModel | null;
  checkoutUrl: string | null;
}
export const initialState: ProfileBoostState = {
  isBoosted: false,
  identityVerifyStatusModel: null,
  checkoutUrl: null,
};
export const profileBoostReducer = (
  state: ProfileBoostState,
  action: ProfileBoostAction,
): ProfileBoostState => {
  switch (action.type) {
    case "TOGGLE_BOOST":
      return { ...state, isBoosted: action.payload };
    case "SET_IDENTITY_VERIFY_STATUS":
      return { ...state, identityVerifyStatusModel: action.payload };
    case "SET_CHECKOUT_URL":
      return { ...state, checkoutUrl: action.payload || null };
    default:
      return state;
  }
};
export const toggleBoost = (payload: boolean): ProfileBoostAction => ({
  type: "TOGGLE_BOOST",
  payload,
});
